export const ExternalLinks = {
  contactSupport: process.env.SUPPORT_REQUEST_URL,
  riskSummaryFCA: process.env.RISK_SUMMARY_FCA_URL,
  termsAndConditions: process.env.TERMS_URL,
  termsAndConditionsDevX: process.env.TERMS_DEVX_URL,
  privacyPolicy: process.env.PRIVACY_POLICY_URL,
  financialCrimeRiskAppetitePolicy: process.env.FINANCIAL_CRIME_RISK_APPETITE_POLICY_URL,
}
